import httpClient from 'utils/httpClient.js';

export const getList = (params = {}) => {
  return httpClient.get('/store', { params });
};

export const getDetailStore = (id) => {
  return httpClient.get(`/store/${id}`);
};

export const getOptionsStore = (params) => {
  return httpClient.get('/store/get-options', { params });
};

export const deleteStore = (id) => {
  return httpClient.delete(`/store/${id}`);
};

export const create = (params) => {
  return httpClient.post(`/store`, params);
};

export const update = (id, params) => {
  return httpClient.put(`/store/${id}`, params);
};

export const deleteStoreList = (list_id = []) => {
  return httpClient.post('/store/delete', { list_id });
};

export const exportExcelStore = (params = {}) => {
  return httpClient.get('/store/export-excel', {
    params,
    responseType: 'blob',
  });
};

export const importExcelStore = (file) => {
  const formData = new FormData();
  formData.append('storeimport', file);
  return httpClient.post('/store/import-excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadTemplateStore = () => {
  return httpClient.get('/store/download-excel', {
    responseType: 'blob',
  });
};

export const getDetail = (id) => {
  return httpClient.get(`/store/${id}`);
};
